import HSHeader from '../front-ui/vendor/hs-header/src/js/hs-header'
import HSMegaMenu from '../front-ui/vendor/hs-mega-menu/src/js/hs-mega-menu'
import HSUnfold from '../front-ui/vendor/hs-unfold/src/js/hs-unfold'
import '../front-ui/js/hs.core'
import '../front-ui/js/hs.validation'
import 'jquery-validation'
import HSShowAnimation from '../front-ui/vendor/hs-show-animation/src/js/hs-show-animation'
import HSCounter from '../front-ui/vendor/hs-counter/src/js/hs-counter'
import HSStickyBlock from '../front-ui/vendor/hs-sticky-block/src/js/hs-sticky-block'
import AOS from 'aos'
import HSGoTo from '../front-ui/vendor/hs-go-to/src/js/hs-go-to'
import HSVideoPlayer from '../front-ui/vendor/hs-video-player/src/js/hs-video-player'

import Typed from '../front-ui/vendor/typed.js/lib/typed'
//Needs Implemenation

import '../front-ui/vendor/simplePagination.js-master/jquery.simplePagination'
import '../front-ui/vendor/jquery-listnav-master/jquery-listnav.min'

$(document).on('ready', function () {


  
    
    // initialization of header
    // var header = new HSHeader($('#header')).init();

    // initialization of mega menu
    var megaMenu = new HSMegaMenu($('.js-mega-menu'), {
        desktop: {
          position: 'left'
        }
      }).init();

    // initialization of unfold
    var unfold = new HSUnfold('.js-hs-unfold-invoker').init();

    // initialization of text animation (typing)
    if($(".js-text-animation")[0]){
        var typed = new Typed(".js-text-animation", {
            strings: ["Sales.", "Service.", "Marketing."],
            typeSpeed: 140,
            loop: true,
            backSpeed: 65,
            backDelay: 1600
        });
    }
    
    // initialization of form validation
    $('.js-validate').each(function() {
       
        var validation = $.HSCore.components.HSValidation.init($(this), {
            rules: {
                inf_field_Phone1: {
                    required: true,
                    digits: true,
                    rangelength: [10, 10],
                },
            }
        });            
    });

 
    
    // initialization of video player
    $('.js-inline-video-player').each(function () {
        var videoPlayer = new HSVideoPlayer($(this)).init();
    });

    // initialization of show animations
    $('.js-animation-link').each(function () {
    var showAnimation = new HSShowAnimation($(this)).init();
    });

    // initialization of counter
    $('.js-counter').each(function() {
    var counter = new HSCounter($(this)).init();
    });

    //Side Bar
    $('.js-sticky-block').each(function () {
        var stickyBlock = new HSStickyBlock($(this)).init();
    });

    // initialization of go to
    $('.js-go-to').each(function () {
    var goTo = new HSGoTo($(this)).init();
    });

    // Scroll to (Section)
    $(function () {
        $('a[href*=#scroll-to-]:not([href=#scroll-to-])').on('click', function () {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - 10
                    }, 1000);
                    return false;
                }
            }
        });
    });

    // initialization of aos for sidebar tabs
    AOS.init({
        duration: 550,
        once: true
    });
    
    $('#demoOne').listnav({
        includeNums: false,
        showCounts: false,
        filterSelector: '.terminology-name',
        noMatchText: '',
        onClick: function(letter) {
            if (letter.toUpperCase() == 'ALL') {
                window.location.href = "/glossary";
            }
        }
    });

    $('.terminology-search').keyup(function(){

         let text = this.value.toLowerCase(); 

        $("#demoOne .terminology-container").each(function( index, element ) {
          

              var term_text = $(element).find('.terminology-name').text().toLowerCase();
              
              if (term_text.search(text) > -1) {
                  $(element).removeClass('listNavHide');
                  $(element).addClass('listNavShow');
              }else{
                  $(element).removeClass('listNavShow');
                  $(element).addClass('listNavHide');
              }

        });
         
         
    });

     function waitForElement(elementPath, callBack){
        window.setTimeout(function(){
          if($(elementPath).length){
            callBack(elementPath, $(elementPath));
          }else{
            waitForElement(elementPath, callBack);
          }
        },500)
      }

      
    $('#chatUsModal').on('show.bs.modal', function (e) {
        $('body').addClass("activeShowChatUsModal");
    });

    $('#chatUsModal').on('hidden.bs.modal', function (e) {
        $('body').removeClass("activeShowChatUsModal");
    });

    $('.ChatUsModalLiveButtons').on('click', function(){
        $('#chatUsModal').modal('hide');
    });

});




/*document.addEventListener('scroll', function() {
    var scrollDepth = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
    if (scrollDepth > 0.4) {
        var requestQuoteButton = document.getElementById('requestQuoteButton');
        if (!requestQuoteButton.classList.contains('clicked')) {
            requestQuoteButton.classList.add('clicked');
            requestQuoteButton.click();
        }
    }
}); */

// Set a timer that triggers after 20 seconds
let timer;

document.addEventListener('DOMContentLoaded', function() {

    timer = setTimeout(function() {
        var requestQuoteButton = document.getElementById('requestQuoteButton');
        if (requestQuoteButton && !requestQuoteButton.classList.contains('clicked')) {
            requestQuoteButton.classList.add('clicked');
            requestQuoteButton.click();
        }
    }, 20000); // 20 seconds in milliseconds
});

document.addEventListener('scroll', function() {
    clearTimeout(timer);
    
    // Restart the timer if needed (optional)
    timer = setTimeout(function() {
        var requestQuoteButton = document.getElementById('requestQuoteButton');
        if (requestQuoteButton && !requestQuoteButton.classList.contains('clicked')) {
            requestQuoteButton.classList.add('clicked');
            requestQuoteButton.click();
        }
    }, 20000);
});


document.addEventListener('DOMContentLoaded', function() {
    var unfoldInvokers = document.querySelectorAll('.js-hs-unfold-invoker');
    unfoldInvokers.forEach(function(invoker) {
        invoker.addEventListener('click', function() {
            var target = document.querySelector(this.getAttribute('data-hs-unfold-options').target);
            if (target.classList.contains('is-visible')) {
                target.classList.remove('is-visible');
                target.style.animation = 'slideOutLeft 0.5s forwards';
            } else {
                target.classList.add('is-visible');
                target.style.animation = 'slideInLeft 0.5s forwards';
            }
        });
    });
});





